import React from 'react';

export const DropdownTableContext = React.createContext();
